var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 364,
    height: 309.436,
    viewBox: "0 0 364 309.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(-201 -965.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M182,0c75.99,0,141.1,39.59,168.461,96.054A134.155,134.155,0,0,1,364,154.718c0,85.448-81.484,154.718-182,154.718S0,240.166,0,154.718,81.484,0,182,0Z",
    transform: "translate(201 965.718)",
    fill: "#effbbd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(-1549.262 88.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(1750.262 991.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M1857.809,1379.871h208.033l70.259-6.889s-12.572-34.1-16-34.611-255.7,0-255.7,0Z",
    transform: "translate(-1832.647 -1277.975)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M2100.671,1221.682c-5.255,2.377-37.021,2.905-37.021,2.905s.718-43.026-32-38.011-27,40.725-27,40.725l-157.309,3.1s2.555-45.357-32.178-40.586c-28.856,3.963-21.442,40.415-21.442,40.415-14.888.848-22.869-1.632-27.1-4.221,0,0,0,0,0,0-3.171-4.939-1.323-7.829-1.138-8.337s-.459-8.914-.55-10.13c-.052-.684,1.288-2.425,2.471-3.818a3.4,3.4,0,0,0,.142-4.142l-1.573-2.145a9.156,9.156,0,0,1-1.064-8.684l3.126-7.91,0,0c10.194-19.354,90.124-24.636,90.124-24.636,12.139-7.71,22.2-13.443,30.077-17.606,12.559-6.641,26.879-13.117,40.736-14.631,37.518-4.1,68.368.544,75.931,1.9,8.836,1.584,53.262,22.964,56.606,24.812s30.613,4.352,34.116,4.823,3.4,4.34,3.4,4.34l.481,3.434,1.832,13.08.445,3.195c2.549,1.407,2.552,5.44,2.552,5.44S2105.923,1219.306,2100.671,1221.682Z",
    transform: "translate(-1764.262 -1122.314)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(22.833 59.356)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 25.978,
    cy: 25.978,
    r: 25.978,
    transform: "translate(0 36.738) rotate(-45)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500-2",
    "data-name": "Group 500",
    transform: "translate(16.422 16.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M1930.517,1432.766a20.316,20.316,0,1,1,20.316-20.316A20.339,20.339,0,0,1,1930.517,1432.766Zm0-38.754a18.438,18.438,0,1,0,18.438,18.438A18.458,18.458,0,0,0,1930.517,1394.012Z",
    transform: "translate(-1910.201 -1392.134)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(17.997 17.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(14.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M1977.935,1434.062h-7.279l2.336-19.949-2.67-18.948,8.319.514-2.773,18.435Z",
    transform: "translate(-1970.322 -1395.164)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(0 6.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M1919.693,1443.97l-3.639-6.3,18.446-7.949,15.076-11.785,3.714,7.461-17.352,6.814Z",
    transform: "translate(-1916.054 -1417.932)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(0.721 5.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M1918.734,1423.185l4-6.082,15.385,12.912,17.3,8.179-5,6.669-13.88-12.445Z",
    transform: "translate(-1918.734 -1417.104)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M1960.383,1449.107a6.778,6.778,0,1,1,6.778,6.778A6.778,6.778,0,0,1,1960.383,1449.107Z",
    transform: "translate(-1948.459 -1429.643)",
    fill: "#afcdfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(234.024 64.843)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 25.978,
    cy: 25.978,
    r: 25.978,
    transform: "translate(0 50.566) rotate(-76.718)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(10.936 10.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M2786.886,1432.766a20.316,20.316,0,1,1,20.316-20.316A20.339,20.339,0,0,1,2786.886,1432.766Zm0-38.754a18.438,18.438,0,1,0,18.438,18.438A18.458,18.458,0,0,0,2786.886,1394.012Z",
    transform: "translate(-2766.57 -1392.134)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(12.51 11.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(14.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M2834.3,1434.062h-7.279l2.337-19.949-2.671-18.948,8.319.514-2.773,18.435Z",
    transform: "translate(-2826.691 -1395.164)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(0 6.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M2776.062,1443.97l-3.639-6.3,18.446-7.949,15.076-11.785,3.714,7.461-17.352,6.814Z",
    transform: "translate(-2772.423 -1417.932)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(0.721 5.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M2775.1,1423.185l4-6.082,15.386,12.912,17.3,8.179-5,6.669-13.88-12.445Z",
    transform: "translate(-2775.102 -1417.104)",
    fill: "#afcdfb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M2816.752,1449.107a6.778,6.778,0,1,1,6.778,6.778A6.778,6.778,0,0,1,2816.752,1449.107Z",
    transform: "translate(-2804.829 -1429.643)",
    fill: "#afcdfb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M1804.334,1335.635l-6.668,7.228a5.059,5.059,0,0,1-3.716,1.628H1773.5a1.581,1.581,0,0,1-1.38-2.35l.584-1.044a15.463,15.463,0,0,1,2.639-3.468.01.01,0,0,1,.006,0,15.519,15.519,0,0,1,10.906-4.477h16.993A1.481,1.481,0,0,1,1804.334,1335.635Z",
    transform: "translate(-1769.857 -1274.903)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M1782.607,1467.663h-5.8a5.3,5.3,0,0,0-4.625,2.713l-.2.356a.539.539,0,0,0,.471.8h6.98a1.727,1.727,0,0,0,1.269-.556l2.276-2.468A.505.505,0,0,0,1782.607,1467.663Z",
    transform: "translate(-1769.855 -1372.406)",
    fill: "#1d2949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M2611.864,1170.855l-86.717,2.059a3.027,3.027,0,0,1-3.1-3.026v-19.98a2.817,2.817,0,0,1,2.859-2.817c36.979.514,49.652,1.545,57.252,4.167,6.7,2.313,22.379,11.822,30.481,16.648A1.587,1.587,0,0,1,2611.864,1170.855Z",
    transform: "translate(-2336.578 -1140.427)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M2274.814,1146.591q2.111.023,4.131.05V1172.7l-83.658,1.986a1.092,1.092,0,0,1-.637-2C2204.424,1166.1,2237.165,1146.164,2274.814,1146.591Z",
    transform: "translate(-2088.702 -1140.056)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M2854.737,1225.624l-.046,0V1222c.3.178.584.348.862.514A1.671,1.671,0,0,1,2854.737,1225.624Z",
    transform: "translate(-2585.836 -1194.508)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M2494.2,1169.634l-10.246-.812.683-27.868h9.563Z",
    transform: "translate(-2303.822 -1135.94)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M2750.3,1179.567h-4.782v-25.026l4.782,2.869Z",
    transform: "translate(-2499.64 -1145.873)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M2203.836,1218.494l2.551,8.449-13.955.332a.828.828,0,0,1-.5-1.5C2195.078,1223.509,2200.917,1219.471,2203.836,1218.494Z",
    transform: "translate(-2084.73 -1191.938)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(103.986 5.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M2188.918,1173.651a1.313,1.313,0,0,1-.751-2.389l.291-.2c.3-.21.64-.44,1.012-.691q.46-.309.984-.656l.528-.347q.6-.394,1.274-.822.481-.306,1-.631l.056-.035.148-.091c.289-.181.594-.371.909-.564l.069-.043c.1-.064.209-.129.315-.193.155-.1.319-.2.485-.3l.7-.422c.67-.4,1.391-.828,2.142-1.261q.348-.2.708-.408.709-.409,1.459-.826h0l.352-.2c1.008-.56,2.029-1.115,3.036-1.65l.331-.175.461-.244c1.918-1.005,3.889-1.99,5.861-2.932l.613-.29q.921-.436,1.873-.871c.21-.1.424-.194.64-.291.422-.193.853-.385,1.29-.577l.654-.288c.651-.287,1.346-.586,2.121-.912q.6-.252,1.211-.5c2.734-1.128,5.521-2.187,8.284-3.149l.6-.21q.342-.118.685-.233l.862-.289.7-.23.028-.009c.243-.08.488-.16.733-.237.444-.142.89-.284,1.339-.423.305-.1.615-.19.926-.285.474-.143.948-.285,1.427-.425l.794-.229q.75-.214,1.506-.421c1-.274,2.016-.541,3.023-.792l.06-.016.268-.067c.428-.106.866-.213,1.307-.316.259-.063.524-.125.79-.186l.2-.046c.2-.045.4-.091.593-.135l.793-.176q.4-.088.8-.172c.269-.057.537-.112.8-.167s.534-.11.806-.163l.044-.009q.382-.076.764-.149c.253-.05.507-.1.764-.146.288-.053.574-.1.863-.156l.556-.1.261-.046c.546-.093,1.09-.184,1.636-.27.272-.044.548-.086.824-.129l.042-.007q.725-.109,1.452-.209c.9-.125,1.811-.241,2.7-.344l.058-.007c.25-.029.5-.057.748-.083.173-.02.357-.039.539-.057s.371-.041.566-.058.417-.042.631-.062c.28-.027.564-.053.85-.077.27-.024.545-.047.819-.067l.636-.05,1.214-.082c.239-.016.478-.029.719-.043l.105-.006c.262-.015.531-.029.8-.041.211-.01.426-.021.642-.029h.021c.192-.008.384-.016.576-.023l.475-.017.568-.017a2.722,2.722,0,0,1,2.8,2.72v21.6a3.353,3.353,0,0,1-3.254,3.332l-76.478,1.816Zm12.63-9.04-.473.264q-.827.461-1.61.91c-.239.137-.472.271-.7.405-.745.431-1.459.851-2.124,1.252-.238.142-.469.281-.7.419q-.243.147-.481.294c-.108.065-.208.127-.307.188l-.073.044q-.469.287-.908.563l-.194.12-.987.626q-.667.425-1.258.812l-.526.345q-.518.343-.973.649-.548.37-1,.683l-.139.1,14.368-.341,61.934-1.47a1.979,1.979,0,0,0,1.921-1.967v-21.6a1.356,1.356,0,0,0-1.394-1.354l-.559.017-.475.017-.563.022h-.023l-.634.029q-.4.018-.789.041l-.106.005c-.233.013-.469.027-.7.042l-1.2.082c-.2.015-.409.031-.616.048-.283.021-.552.043-.819.067-.283.024-.562.05-.841.077-.211.019-.417.039-.625.06-.191.018-.372.036-.552.057s-.363.037-.537.057c-.253.026-.5.054-.74.082l-.057.006c-.878.1-1.776.216-2.669.34-.479.066-.958.136-1.434.207l-.039.006c-.273.042-.546.084-.817.127-.542.086-1.081.176-1.617.267l-.261.046c-.182.032-.364.063-.546.1-.288.051-.572.1-.855.155l-.756.144-.759.148-.044.009c-.265.052-.529.1-.792.16s-.534.11-.8.166-.526.112-.789.17-.525.115-.788.175c-.2.044-.39.088-.583.133l-.2.046c-.261.059-.519.12-.778.183-.439.1-.871.208-1.3.315l-.254.063-.064.016c-1,.249-2.006.514-3,.786q-.751.205-1.491.417l-.789.227c-.469.138-.942.279-1.411.421q-.459.139-.915.281c-.448.138-.89.28-1.331.421-.242.076-.481.154-.721.233l-.03.01q-.345.113-.691.227l-.857.287c-.225.076-.451.152-.674.229l-.6.209c-2.74.954-5.5,2-8.214,3.122-.4.167-.805.334-1.2.5-.768.323-1.455.619-2.1.9l-.652.287q-.647.285-1.277.572c-.216.1-.424.191-.632.287-.633.289-1.251.576-1.861.865l-.611.289c-1.953.932-3.909,1.91-5.809,2.905l-.463.244-.327.173C2203.371,1163.612,2202.455,1164.109,2201.548,1164.61Z",
    transform: "translate(-2187.605 -1144.186)",
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(248.526 12.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M2763.082,1187.867a1.957,1.957,0,0,1-1.373-.568,2.242,2.242,0,0,1-.661-1.6v-14.581c0-.83.123-1.889.794-2.307a2.652,2.652,0,0,1,2.272.211c.714.351,1.211.6,1.479.747.029.014.068.036.108.058l.291.158c3.634,1.985,8.807,5.109,15.378,9.286.28.177.558.354.834.53.663.422,1.307.835,1.927,1.234l2.3,1.487,1.151.749.164.105.05.033a2.115,2.115,0,0,1,.848,2.372,1.94,1.94,0,0,1-1.818,1.471l-.251.006-23.447.609Zm.128-17.849a.858.858,0,0,0-.451.134,1.118,1.118,0,0,0-.5.966V1185.7a1.024,1.024,0,0,0,.3.734.759.759,0,0,0,.548.224l23.7-.615a.755.755,0,0,0,.684-.591.907.907,0,0,0-.342-1.028l-.05-.033-.159-.1c-.372-.242-.755-.492-1.155-.751l-2.3-1.484c-.62-.4-1.263-.811-1.925-1.233q-.411-.263-.831-.528c-6.55-4.164-11.7-7.274-15.31-9.247l-.294-.16-.089-.048c-.262-.142-.759-.392-1.448-.731A.838.838,0,0,0,2763.211,1170.017Z",
    transform: "translate(-2761.048 -1168.626)",
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M2203.836,1218.494l2.551,8.449-13.955.332a.828.828,0,0,1-.5-1.5C2195.078,1223.509,2200.917,1219.471,2203.836,1218.494Z",
    transform: "translate(-2084.73 -1191.938)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(186.65 5.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M2523.211,1171.741a3.709,3.709,0,0,1-3.7-3.709v-19.98a3.5,3.5,0,0,1,3.551-3.5c38.168.531,49.987,1.4,57.483,4.211l.443.166v21.442l-57.68,1.368Zm-.2-25.823a2.135,2.135,0,0,0-2.135,2.134v19.98a2.342,2.342,0,0,0,2.4,2.342l56.346-1.337v-19.157c-7.294-2.589-19.8-3.451-56.579-3.962Z",
    transform: "translate(-2519.506 -1144.553)",
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M3029.4,1282.789h-16.327a7.922,7.922,0,0,1-6.227-3.023l-6.174-7.847a1.127,1.127,0,0,1,.886-1.825h25.878Z",
    transform: "translate(-2692.567 -1229.256)",
    fill: "#a9453d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(185.234 6.323)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 87.498,
    height: 0.683,
    transform: "matrix(0.012, -1, 1, 0.012, 0, 87.492)",
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(77.601 94.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 168.818,
    height: 0.683,
    transform: "translate(0 3.377) rotate(-1.146)",
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M2419.3,1306.507c0,.925-4.128,1.676-9.221,1.676s-9.221-.75-9.221-1.676,4.129-1.676,9.221-1.676S2419.3,1305.581,2419.3,1306.507Z",
    transform: "translate(-2241.801 -1254.493)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M2738.57,1306.507c0,.925-4.128,1.676-9.221,1.676s-9.221-.75-9.221-1.676,4.128-1.676,9.221-1.676S2738.57,1305.581,2738.57,1306.507Z",
    transform: "translate(-2481.304 -1254.493)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(231.078 31.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M2695.411,1297.921l-.682-.037c.471-8.7,3.049-16.029,7.662-21.788a36.186,36.186,0,0,1,14.832-10.739,56.179,56.179,0,0,1,20.533-3.9v-26.016h.683v26.722l-.356-.015a55.192,55.192,0,0,0-20.622,3.852,35.508,35.508,0,0,0-14.545,10.535C2698.4,1282.177,2695.875,1289.374,2695.411,1297.921Z",
    transform: "translate(-2694.729 -1235.439)",
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(101.806 35.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M2170.626,1310.353c-.265-22.567.992-38.18,2.093-47.3a110.954,110.954,0,0,1,2.484-14.573l.658.184c-.051.181-5.057,18.605-4.552,61.687Z",
    transform: "translate(-2170.59 -1248.474)",
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(179.777 6.323)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 13.361,
    height: 0.683,
    fill: "#1d2949"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M1785.409,1356.659H1773.5a1.581,1.581,0,0,1-1.38-2.351l.584-1.044a15.46,15.46,0,0,1,2.639-3.468.009.009,0,0,1,.006,0l7.21,1.195-2.849,3.12,3.406.687Z",
    transform: "translate(-1769.857 -1287.009)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    d: "M5.013,0H12.9a5.014,5.014,0,0,1,5.014,5.014v0A5.014,5.014,0,0,1,12.9,10.027H5.013A5.013,5.013,0,0,1,0,5.014v0A5.013,5.013,0,0,1,5.013,0Z",
    transform: "translate(116.376 28.647)",
    fill: "#6390e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(1811.97 939.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M2012.218,1098.951c.726,1.951,1.983,4.214,3.3,4.777a5.114,5.114,0,0,1,2.12,1.54l1.208-.7,1.443-.839s-.034-.16-.1-.421-.178-.622-.324-1.023a1.4,1.4,0,0,1-.171-1.284,2.981,2.981,0,0,0-.246-2.49c-.463-.672-.909-2.33-1.188-2.281-.674.116.332,2.394.043,2.816a.5.5,0,0,1-.648.222l-.012-.006c-1.893-.833-4.189-5.319-5.205-4.714C2012.055,1094.774,2011.908,1098.12,2012.218,1098.951Z",
    transform: "translate(-2008.582 -1059.683)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    transform: "translate(0 32.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M2013.263,1096.572l-2.371,1.667a.374.374,0,0,1-.519-.091l-6.075-8.644a.373.373,0,0,1,.091-.519l2.371-1.666a.373.373,0,0,1,.519.091l6.075,8.644A.373.373,0,0,1,2013.263,1096.572Z",
    transform: "translate(-2003.078 -1087.252)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M2008.354,1101.761l-1.39.977a.284.284,0,0,1-.394-.069l-6.177-8.789a.284.284,0,0,1,.069-.395l1.39-.977a.284.284,0,0,1,.395.069l6.177,8.789A.284.284,0,0,1,2008.354,1101.761Z",
    transform: "translate(-2000.341 -1090.916)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M2064.409,1076.843s-12.067,21.046-16.444,24.919l-16.052-11.967a5.858,5.858,0,0,0-3.349,3.052s9.747,19.859,19.344,20.7,23.067-23.8,23.067-23.8Z",
    transform: "translate(-2020.205 -1047.256)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(31.048 80.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M2241.6,1526.5h6.972a4.225,4.225,0,0,0,1.906-3.195c.341-2.246,2.859-3.471,3.4-5.309s-2.246-4.422-2.246-4.422l-.467-.6-.485-.625-4.627,1.089s-.115,1.1-.184,2.506a32.041,32.041,0,0,0-.021,3.21c.136,2.449-.685,5.088-2.862,5.564C2241.38,1525.071,2241.452,1526.025,2241.6,1526.5Z",
    transform: "translate(-2201.138 -1431.99)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M2105.165,1540.75h15.944c.767-.936.485-4.389.369-5.517-.024-.227-.041-.36-.041-.36s-5.445-4.355-6.193-1.02c-.023.1-.05.207-.08.308-.942,3.119-5.168,4.536-7.609,4.931A2.764,2.764,0,0,0,2105.165,1540.75Z",
    transform: "translate(-2105.165 -1446.24)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M2115.422,1256.257s.827,10.315,1.8,22.714c1.32,16.843,2.909,37.532,3.066,41.451.271,6.806,1.361,17.692,1.361,17.692s2.584,2.586,7.757,1.5a178.153,178.153,0,0,0,5.926-31.983c.02-.269.041-.541.061-.812,1.225-16.739,3.129-51.986,3.129-51.986Z",
    transform: "translate(-2112.384 -1250.745)",
    fill: "#ffa25c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M2115.422,1256.257s.827,10.315,1.8,22.714l18.111,28.656c.02-.269.041-.541.061-.812,1.225-16.739,3.129-51.986,3.129-51.986Z",
    transform: "translate(-2112.384 -1250.745)",
    fill: "#ef8c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M2128.168,1247.781s14.9,37.356,24.7,54.911,12.86,22.454,12.86,22.454,5.614-2.246,6.124-3.776c0,0-3.747-33.891-10.309-42.153-3.708-4.669-8.063-18.678-8.267-23.578s-1.327-14.595-1.327-14.595Z",
    transform: "translate(-2121.354 -1241.045)",
    fill: "#ffa25c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M2140.692,1043.032c5.823,1.837,15.9-3.122,15.9-3.122s-5.369-4.029-5.088-12.407l-4.5,3.628-3.058,2.464a36.6,36.6,0,0,0,.347,4c.088.67.2,1.417.337,2.232A13.931,13.931,0,0,0,2140.692,1043.032Z",
    transform: "translate(-2099.121 -1013.214)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M2151.665,1042.01a36.573,36.573,0,0,0,.346,4c3.389-.582,7.233-6.059,7.233-6.059a10.8,10.8,0,0,0-4.522-.4Z",
    transform: "translate(-2106.844 -1021.628)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M2141.193,1009.8s9.619,1.6,10.521-4.407,2.753-9.843-3.351-11.118-7.643.838-8.432,2.769S2138.715,1009.226,2141.193,1009.8Z",
    transform: "translate(-2098.153 -989.553)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M2112.792,1121.1a.943.943,0,0,0,.612.233c2.187-.029,8.563,1.185,13.959.631a40.2,40.2,0,0,0,12.9-3.722c.574-.257,1.9-.963,1.866-1.6-.02-.7-.089-1.722-.177-3.005a160.8,160.8,0,0,1-.32-20.993c.094-1.649.143-3.285.149-4.895.045-12-2.335-22.558-7.117-26.131-.409-.293-2.916.933-5.22,2.069a9.537,9.537,0,0,1-6.269.759l-2.011,1.779a20.1,20.1,0,0,0-6.3,10.06c-.992,3.995-1.574,11.2-1.9,18.663-.146,3.383-.263,6.795-.293,10.032v.116c-.028.321-.028.672-.028.992C2112.529,1114.392,2112.647,1120.982,2112.792,1121.1Z",
    transform: "translate(-2079.349 -1037.19)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M2189.552,1156.016a160.8,160.8,0,0,1-.32-20.994c.094-1.649.143-3.285.149-4.895-1.992-4.833-3.62-8.337-3.62-8.337h-5.022S2177.059,1146.935,2189.552,1156.016Z",
    transform: "translate(-2126.95 -1078.594)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M2243.551,1236.779a7.43,7.43,0,0,1,1.169,2.1c.3,4.057-1.551,4.618,3.248,6.872,0,0,2.049.781,2.084-.809s-1.422-1.617-1.156-3.844c.307-2.569.276-2.593-1.41-3.935l-1.116-1.845Z",
    transform: "translate(-2171.513 -1157.969)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M2191.97,1117.644a16.458,16.458,0,0,1-3.769.21s-5.367-16.582-6.058-18.1-15.945-19.443-15.945-19.443l6.354-15.9s16.5,27.558,18.173,31.431c2.768,6.4,3.729,20.745,3.729,20.745A6.915,6.915,0,0,1,2191.97,1117.644Z",
    transform: "translate(-2117.073 -1039.19)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M2145.779,994.52s-.987-.165-.828-1.525.157-3.136-.948-2.805-1.161,1.216-1.615.7-.463-2.695-3.751-2.846-4.626.993-6.155.321-1.61-2.987-1.61-2.987a2.628,2.628,0,0,0,1.092,1.09s-2.552-3.49.4-5.883,5.967-.826,7.676-.723c3.767.228,6.2.454,7.431,2.929S2148.2,992.137,2145.779,994.52Z",
    transform: "translate(-2092.209 -979.262)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M2245.522,1246.281s-1.083,1.129-1.151,1.6c-.22,1.508-.723,2.159-.471,2.323.524.341,1.219-.775,1.55-1.777A4.576,4.576,0,0,0,2245.522,1246.281Z",
    transform: "translate(-2171.711 -1165.684)",
    fill: "#ffb27d"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.c904f0b14b2ada939392d82ef5fc9223.svg";
export { ForwardRef as ReactComponent };